export const UserMessage = 
{
    Login_500: "Sorry, we can't process this request right now, please try again later.",
    CreateUser_200: "User created successfully.",
    UpdateUser_200: "User updated successfully.",
    CreateUser_400: "Create user failed, please try again later.",
    ChangeProfilePicture_200: "Change profile picture successfully.",
    ChangePassword_200: "Change password successfully, you will now be redirect to Login Page."
}